import React, { createContext, useReducer, useCallback } from "react";
import AppReducer from "./AppReducer";

const initialState = {
  transactionLoader: false,
  userData: null,
};

export const GlobalContext = createContext(initialState);

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  const setTransactionLoaderState = (loaderState) => {
    dispatch({ type: "SET_TRANSACTION_LOADER", payload: loaderState });
  };

  const setUserData = useCallback((data) => {
    dispatch({ type: "SET_USER_DATA", payload: data });
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        transactionLoader: state.transactionLoader,
        userData: state.userData,
        setTransactionLoaderState,
        setUserData,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
